import React, { ReactElement } from 'react';
import styles from './EmptyView.module.scss';
import { ButtonProps, Typography } from '@mui/material';
import { Button } from 'new/elements/Button';

interface EmptyViewProps {
  icon?: ReactElement;
  title: string;
  message?: string;
  actionTitle?: string;
  onClick?: () => void;
  containerClassName?: string;
  actionProps?: ButtonProps;
}

export const EmptyView = (props: EmptyViewProps) => {
  const { icon, title, message, actionTitle, onClick, actionProps, containerClassName } = props;
  return (
    <div className={[styles.container, containerClassName || ''].join(' ')}>
      {icon ? <div className={styles.iconContainer}>{icon}</div> : null}
      <Typography variant="subtitle1" className={styles.title}>
        {title}
      </Typography>
      {message ? (
        <Typography variant="body2" className={styles.message}>
          {message}
        </Typography>
      ) : null}
      {actionTitle ? (
        <Button variant="contained" color="primary" onClick={onClick} {...actionProps}>
          {actionTitle}
        </Button>
      ) : null}
    </div>
  );
};
